module.exports = __webpack_public_path__ + "047d7abf2b0dca51b30564144079e583.pdf";